import { Box, MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import Textarea from "../textarea"

import ColumnBlock from "./column-block"
import FlexCarousel from "./flex-carousel"

const Column = styled(Box).attrs((props) => ({
  flex: { _: "1 1 100%", tablet: "1" },
  position: "relative",
  ...props,
}))``

const FlexBlock = ({ element, lazyload }) => {
  const columns = element.columns.map((column, index) => (
    <Column key={`${column.id}-${index}`} {...column.column_style}>
      <ColumnBlock column={column} element={element} lazyload={lazyload} />
    </Column>
  ))

  return (
    <Box {...element.style?.flex_block_style}>
      {element.heading && (
        <Box
          mb={{ _: 4, tablet: 5 }}
          px={3}
          textAlign="center"
          {...element.style?.heading_container_style}
        >
          <Textarea
            element={element.heading}
            linkClickData={element?.anchor_name || element?.id}
          />
        </Box>
      )}
      <Box contain={element.contain} {...element.style?.container_style}>
        <Box flex="1" {...element.style?.columns_container_style}>
          {element.data?.flex_textarea && (
            <Textarea
              element={element.data.flex_textarea}
              linkClickData={element?.anchor_name || element?.id}
              style={element.data.flex_textarea.style}
            />
          )}
          {element.data?.show_slider && (
            <FlexCarousel element={element}>{columns}</FlexCarousel>
          )}
          <Box
            display="flex"
            {...element.style?.wrapper_style}
            {...(element.data?.show_slider && {
              as: MediaBox,
              greaterThanOrEqual: "tablet",
            })}
          >
            {columns}
          </Box>
        </Box>
        <Box flex="1" {...element.style?.textarea_container_style}>
          {element.textarea && (
            <Textarea
              element={element.textarea}
              linkClickData={element?.anchor_name || element?.id}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}

FlexBlock.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default FlexBlock
